import _ from 'underscore';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { UiBlocker } from '@bingads-webui-react/ui-blocker';

const BlockerContext = createContext({ block: () => _.noop });

export function BlockerProvider(props) {
  const [queue, updateQueue] = useState([]);

  const value = useMemo(() => {
    let items = [];

    return {
      block: (text) => {
        const item = { text };
        items.push(item);
        updateQueue(items);

        return () => {
          items = _.without(items, item);
          updateQueue(items);
        };
      },
    };
  }, [updateQueue]);

  const firstItem = queue[0];

  return (
    <UiBlocker
      blocking={!!firstItem}
      loadingText={firstItem ? firstItem.text : ''}
    >
      <BlockerContext.Provider value={value}>
        {props.children}
      </BlockerContext.Provider>
    </UiBlocker>
  );
}

BlockerProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export function Blocker(props) {
  const value = useContext(BlockerContext);
  const { loadingText } = props;

  useEffect(
    () => value.block(loadingText),
    [value, loadingText]
  );

  return null;
}
